import {
  Box,
  Tabs,
  Tab,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import AddYogurtType from "../../Modals/addYougurtType";

const ManageYogurtType = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [rows] = useState([
    {
      id: 1,
      name: "Frozen Greek Yogurt",
      method: 'Per 100g',
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "Classic Greek Yogurt",
      method: 'Size vise (S/M/L)',
      createdDate: "03-Sept-2025",
      status: false,
    }
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Yogurt Types</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Yogurt Types
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add New Type
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Type Name</TableCell>
                <TableCell>Pricing Method</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.method}</TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <Button className="btn btn_primary" onClick={() => navigate("/manage-yogurt-types/detail")}>Manage</Button>
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div >

      <AddYogurtType
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageYogurtType;
